import { Controller } from "@hotwired/stimulus"

// Behaviour for a single set row.
export default class extends Controller {
  // Normalize a comma decimal separator (what some mobile locale keyboards show
  // on the inputmode="decimal" keypad) to a dot, so the saved weight is always
  // dot-decimal regardless of device region.
  normalize(event) {
    const input = event.target
    if (!input.value.includes(",")) return

    const start = input.selectionStart
    input.value = input.value.replace(/,/g, ".")
    if (start != null) input.setSelectionRange(start, start)
  }
}
